module.exports = __webpack_public_path__ + "static/media/notepad.f8d2e5a3.svg";